/** Время холдирования мест и оплаты заказа (минуты) */
export const PAYMENT_HOLD_MINUTES = 7
export const PAYMENT_HOLD_SEC = PAYMENT_HOLD_MINUTES * 60

export function parseApiDate(value: string | number | null | undefined): number | null {
    if (value == null || value === "") return null

    if (typeof value === "number" && Number.isFinite(value)) {
        return value > 1e12 ? value : value * 1000
    }

    const raw = String(value).trim()
    if (/^\d+$/.test(raw)) {
        const n = Number(raw)
        return n > 1e12 ? n : n * 1000
    }

    const normalized = raw.replace(" ", "T").replace(/([+-]\d{2})(\d{2})$/, "$1:$2")
    const t = Date.parse(normalized)
    return Number.isNaN(t) ? null : t
}

/**
 * Дедлайн оплаты: `expired_at` из API, иначе `created_at` + 7 минут.
 * Всегда возвращает ISO-строку для единообразного парсинга в таймере.
 */
export function getPaymentExpiresAt(
    createdAt?: string | number | null,
    expiredAt?: string | number | null
): string | undefined {
    const expiredMs = expiredAt != null ? parseApiDate(expiredAt) : null
    if (expiredMs != null) return new Date(expiredMs).toISOString()

    const createdMs = createdAt != null ? parseApiDate(createdAt) : null
    if (createdMs != null) return new Date(createdMs + PAYMENT_HOLD_SEC * 1000).toISOString()

    return undefined
}

export function extractOrderHoldDates(order: {
    created_at?: string
    expired_at?: string
    created?: number
    expired?: number
}) {
    const createdAt =
        order.created_at ??
        (typeof order.created === "number" ? new Date(order.created * 1000).toISOString() : undefined)

    const expiredAt =
        order.expired_at ??
        (typeof order.expired === "number" ? new Date(order.expired * 1000).toISOString() : undefined)

    if (createdAt || expiredAt) {
        return {
            orderCreatedAt: createdAt,
            orderExpiredAt: getPaymentExpiresAt(createdAt, expiredAt),
        }
    }

    const now = Date.now()
    return {
        orderCreatedAt: new Date(now).toISOString(),
        orderExpiredAt: new Date(now + PAYMENT_HOLD_SEC * 1000).toISOString(),
    }
}
